import script from "./forgetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./forgetPassword.vue?vue&type=script&setup=true&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=7558e935&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7558e935"]])

export default __exports__